import "./SiteFooter.css";
import { Link } from "react-router-dom";

const LINKEDIN_URL = "https://www.linkedin.com/company/looporadata-ai/";
const CRUNCHBASE_URL = "https://www.crunchbase.com/organization/looporadata-ai";

/**
 * Marketing footer: social links, copyright.
 * Blog link is commented out until the blog is live — see content.md.
 */
export default function SiteFooter({
  linkedInHref = LINKEDIN_URL,
  crunchbaseHref = CRUNCHBASE_URL,
  onLinkedInClick,
  onCrunchbaseClick,
}) {
  return (
    <footer className="site-footer">
      <div className="site-footer__container">
        <div className="site-footer__grid">
          <div
            className="site-footer__actions"
            aria-label="Connect with LooporaData"
          >
            <a
              className="site-footer__icon-text-link"
              href={linkedInHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => onLinkedInClick?.()}
            >
              <img
                className="site-footer__linkedin-icon"
                src={`${process.env.PUBLIC_URL || ""}/images/InBug-White.png`}
                alt=""
                width={25}
                height={25}
                decoding="async"
              />
              <span>Connect with us on LinkedIn</span>
            </a>
            <a
              className="site-footer__icon-text-link"
              href={crunchbaseHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => onCrunchbaseClick?.()}
            >
              <img
                className="site-footer__social-icon"
                src={`${process.env.PUBLIC_URL || ""}/images/crunchbase-logo.png`}
                alt=""
                width={50}
                height={25}
                decoding="async"
              />
              <span>Explore our Crunchbase profile</span>
            </a>
            {/* Blog — enable when live: <a className="site-footer__link" href="https://www.looporadata.ai/blog">Blog</a> */}
          </div>
        </div>

        <div className="site-footer__legal">
          <p className="site-footer__legal-links">
            <Link className="site-footer__link" to="/privacy">
              Privacy Policy
            </Link>
            {" · "}
            <Link className="site-footer__link" to="/terms">
              Terms of Use
            </Link>
          </p>
          <p className="site-footer__copyright">
            ©2026 LooporaData, Inc. All rights reserved.
          </p>
          <p className="site-footer__tagline">
            Data providers retain control over approved access, permitted use, and outputs.
          </p>
        </div>
      </div>
    </footer>
  );
}
